import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
// Este de abajo reemplazarlo por la clase de medical-cases
import { User } from '../../class/user';

@Injectable()
export class MedicalCasesEventService extends WebService {
    public getMedicalCasesEvent(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined)
            params.append('_page', String(page));
        else
            params.append('_page', '1');

        if (per_page !== null && per_page !== undefined)
            params.append('_limit', String(per_page));
        else
            params.append('_limit', '10');

        if (sort !== null && sort !== undefined)
            params.append('_sort', String(sort));

        if (query !== null && query !== undefined && query !== '')
            params.append('_q', String(query));

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        const options = new RequestOptions({search: params, headers: this.headers});
        
        return this.http.get( `${this.apiUrl}/medical-cases?${params}`, options);
    }

    public infoMedicalCaseEvent(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/medical-cases?id=${id}`,  { headers: this.headers } );
    }

    public newMedicalCaseEvent(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/medical-cases`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateMedicalCaseEvent(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/medical-cases/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteMedicalCaseEvent(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/medical-cases/${id}`, { headers: this.headers } );
    }
}




// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/medical-cases-event/medical-cases-event.service.ts